import React from "react"
import { SocialAccount } from "types/influencer"
import InfluencerCardHeader from "./InfluencerCardHeader"
import { CampaignApplication } from "types/campaign/applications"
import InfluencerStats from "./InfluencerStats"
import { ACCOUNT_NOT_FOUND_MSG } from "constants/global"
import { formatNumber } from "utils/helpers"

interface InfluencerCardProps {
    name: string,
    language?: string
    gender?: string,
    location?: string,
    socialAccount?: SocialAccount,
    application: Pick<CampaignApplication, 'requirement_match' | 'requirement_match_details' | 'authenticity_score' | 'authenticity_score_details' | 'average_views'>
}

const InfluencerCard: React.FC<InfluencerCardProps> = ({ name, socialAccount, gender, location, application, language }) => {
    return (
        <div className="influencer-card">
            <InfluencerCardHeader
                name={name}
                gender={gender}
                location={location}
                socialAccount={socialAccount}
                language={language}
                headerRightContent={
                    <div className="application-card-action d-flex flex-column justify-content-center gap-2">
                        <span className="application-action navigate-icon text-primary bg-primary-light"><i className="mdi mdi-arrow-top-right" /></span>
                    </div>
                }
            />
            {
                socialAccount ? (
                    <div className="px-2">
                        <div className="application-card__stats social-account-stats social-account-stats--cols-3">
                            <div className="social-account-stats__cell">
                                <p className="social-account-stats__value">
                                    {socialAccount.engagement_score ?? 'NA'}
                                </p>
                                <p className="social-account-stats__label">Engg Score</p>
                            </div>
                            <div className="social-account-stats__cell">
                                <p className="social-account-stats__value">
                                    {application.average_views
                                        ? formatNumber(parseInt(application.average_views))
                                        : 'NA'}
                                </p>
                                <p className="social-account-stats__label">Avg Views</p>
                            </div>
                            <div className="social-account-stats__cell">
                                <p className="social-account-stats__value">
                                    {formatNumber(socialAccount.followers_count)}
                                </p>
                                <p className="social-account-stats__label">Followers</p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="account-not-available-card">
                        <span className="w-75">{ACCOUNT_NOT_FOUND_MSG}</span>
                    </div>
                )
            }
        </div>
    )
}

export default InfluencerCard
